/*
* Created on Apr 01, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import {useRegion} from "../context/RegionContext";
import qs from "qs";
import axios from "axios";
import Cookies from "js-cookie";

export const useAuthService = () => {
    const {url} = useRegion();

    const AUTHAPI = {
        DEFAULT_CONFIG: {
            baseURL: `${url.get_oauth_api_url()}/oauth`,
            timeout: 1000,
            headers: {'X-QNAP-APP-ID': ''}
        },
        get_cookies_settings: () => {
            const cookie_consent = Cookies.get('cookiesconsent');
            if (cookie_consent) {
                const cc_json = JSON.parse(cookie_consent);
                return cc_json;
            }
            return {is_cookies_set: false , FC: true, AC: true, SC: true}
        },
        set_cookies: (input_data) => {
            Cookies.set('cookiesconsent', JSON.stringify(input_data), { expires: 30 });
        },
        // get_cookies_settings: async () => {
        //     const custom_config = {
        //         method: 'GET',
        //         withCredentials: true,
        //         headers: {'CSRF-Token': Cookies.get('XSRF-TOKEN')},
        //         url: `${url.get_org_center_domain()}/ajax/cookieSettings`
        //     }
        //     try {
        //         const { data } = await axios(custom_config);
        //         return data;
        //     } catch (err) {
        //         throw err;
        //     }
        // },
        // set_cookies: async (input_data) => {
        //     const custom_config = {
        //         method: 'POST',
        //         withCredentials: true,
        //         data: input_data,
        //         headers: {'CSRF-Token': Cookies.get('XSRF-TOKEN'), 'X-QNAP-APP-ID': '', 'content-type': 'application/json'},
        //         url: `${url.get_org_center_domain()}/ajax/cookieSettings`
        //     }
        //     try {
        //         const { data } = await axios(custom_config);
        //         return data;
        //     } catch (err) {
        //         throw err;
        //     }
        // },
        do_receive_auth: async (param_string) => {
           const custom_config = {
                method: 'GET',
                params: param_string,
                withCredentials: true,
                headers: {'content-type': 'application/x-www-form-urlencoded'},
                url: `${url.get_org_center_domain()}/do_receive_auth`
            }
            try {
                const { data } = await axios(custom_config);
                return data;
            } catch (err) {
                sessionStorage.removeItem('access_token');
                throw err;
            }
        },
        refresh_token: async () => {
            const custom_config = {
                method: 'POST',
                withCredentials: true,
                headers: {'content-type': 'application/x-www-form-urlencoded'},
                url: `${url.get_org_center_domain()}/ajax/refresh_token`
            }
            try {
                const { data } = await axios(custom_config);
                sessionStorage.setItem('access_token', data?.result.access_token);
                return data.result.access_token;
            } catch (err) {
                sessionStorage.removeItem('access_token');
                throw err;
            }
        },
        token_status: async (access_token) => {
            const { data } = await axios.get(`/tokeninfo?access_token=${access_token}`, (AUTHAPI.DEFAULT_CONFIG));
            return data;
        },
        user_info: async () => {
            const custom_config = {
                timeout: 5000,
                headers: {'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`}
            }
            const {data} = await axios.get(`${url.get_oauth_api_url()}/v1.2/me`, custom_config);
            return data;
        },
        search_user_info: async (params) => {
            const user = await fetch(`/ajax/user`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'CSRF-Token': Cookies.get('XSRF-TOKEN')
                },
                body: JSON.stringify(params)
            });
            const user_json = await user.json();
            return user_json;
        },
        logout: () => {
            const urls = `${url.get_acc_url()}/signout`;
            const params = {
                app_id: window._env_.REACT_APP_OAUTH_CLINET_ID,
                redirect_uri: `${url.get_org_center_domain()}/oauth/receive_auth`
            }
            window.location = `${urls}?${qs.stringify(params)}`;
        }
    };

    return {AUTHAPI};
};
